"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationPolygon$ = exports.LocationPolygon$outboundSchema = exports.LocationPolygon$inboundSchema = void 0;
exports.locationPolygonToJSON = locationPolygonToJSON;
exports.locationPolygonFromJSON = locationPolygonFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.LocationPolygon$inboundSchema = z.object({
    coordinates: z.array(z.array(z.array(z.number()))),
    type: z.string(),
});
/** @internal */
exports.LocationPolygon$outboundSchema = z.object({
    coordinates: z.array(z.array(z.array(z.number()))),
    type: z.string(),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var LocationPolygon$;
(function (LocationPolygon$) {
    /** @deprecated use `LocationPolygon$inboundSchema` instead. */
    LocationPolygon$.inboundSchema = exports.LocationPolygon$inboundSchema;
    /** @deprecated use `LocationPolygon$outboundSchema` instead. */
    LocationPolygon$.outboundSchema = exports.LocationPolygon$outboundSchema;
})(LocationPolygon$ || (exports.LocationPolygon$ = LocationPolygon$ = {}));
function locationPolygonToJSON(locationPolygon) {
    return JSON.stringify(exports.LocationPolygon$outboundSchema.parse(locationPolygon));
}
function locationPolygonFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.LocationPolygon$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'LocationPolygon' from JSON`);
}
//# sourceMappingURL=locationpolygon.js.map